
//import {functions, auth} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import PhoneAuth from "@/components/PhoneAuth.vue"
//import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'

@Component({
  components: {
    
    PhoneAuth
  }
})

export default class ChangePhoneNumber extends Mixins(Common) {
  isLoading =  false
  notice: NoticeProps = {}

  get phoneNumberNow(){
    return this.$store.state.user.phoneNumber
  }
  
  mounted(){
    console.log('mounted');
  }

  async created() {
    console.trace('created')
  }
}
